import {getStationCode} from "../network/NetworkUtil";
import {TIMEOUT_STRING} from "../util/Constants";

const postMessagePromises = {};
function generateGuid(){
    /**
     * @return {string}
     */
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
            },timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

var setCurrentDarkMode = () => {};
export function setDarkModeStateListener(darkModeStateListener) {
  setCurrentDarkMode = darkModeStateListener;
}

export async function getDarkModeStatus() {
    return await postMessagePromised(
      window.parent,
      {
        method: "getDarkModeStatus",
        args: {},
      },
      "*",
    );
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");

    const stationArgs = {...args, processName: args.processName + "_" + getStationCode()}
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: stationArgs
    }, "*");
}

export async function getCycleDataFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getCycleDataFromParent',
        args: {}
    }, '*');
}

export async function getAPIGatewayDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}

export async function getDocumentURL() {
    return await postMessagePromised(window.parent, {
        method: 'getDocumentURL',
        args: {}
    }, '*');
}

export async function getUserName() {
    return await postMessagePromised(window.parent, {
        method: 'getEmployeeName',
        args: {}
    }, '*');
}

export async function getNodeCapabilityFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getNodeCapability',
        args: {}
    }, '*');
}

export async function getLocaleFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getLocale',
        args: {}
    }, '*',200);
}

export function setSelectedCycle(selectedCycle) {
    window.parent.postMessage({
        method: 'setSelectedCycle',
        args: {selectedCycle: selectedCycle}
    }, "*");
}

export async function getFeaturesFromParent(features) {
    return await postMessagePromised(window.parent, {
        method: 'getFeatureStatus',
        args: {features, stationCode: getStationCode()}
    }, '*');
}

/**
 * Fetches the force-induct restricted-status remote config (AppConfig/g2s2/SDC) for the current
 * station. The config maps a station to the set of cycles for which one or more force-induct
 * statuses (e.g. ENABLED) must be hidden from the dropdown.
 *
 * This reuses the existing getFeatureStatus postMessage channel, so it is backward compatible:
 * if the parent frame does not serve this key, the resolved payload simply will not contain it
 * and no restrictions are applied.
 *
 * @param {string} configKey remote config feature key to request
 * @returns resolved remote config payload
 */
export async function getForceInductRestrictedStatusConfig(configKey) {
    return await postMessagePromised(window.parent, {
        method: 'getFeatureStatus',
        args: {features: [configKey], stationCode: getStationCode()}
    }, '*');
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

const subscribeAbleEvents = {
    "sendCycleDataToChild": sendCycleDataToChild,
    "sendApiGatewayResponse": sendApiGatewayResponse,
    "sendDocumentURL": sendDocumentURL,
    "sendCapabilityResponse": sendCapabilityResponse,
    "sendLocaleResponse": sendResponse,
    "sendFeatureStatus": sendResponseData,
    "sendEmployeeNameResponse": sendEmployeeNameResponse,
    "sendDarkModeStatus": sendDarkModeStatus,
    sendTcpRolesWithRootStationsResponse: sendTcpRolesWithRootStationsResponse,

}

function sendDarkModeStatus(data) {
    setCurrentDarkMode(data.childData.capability);
}

function sendCycleDataToChild(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendApiGatewayResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendDocumentURL(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendCapabilityResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendResponseData(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendEmployeeNameResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

export async function getTCPRolesWithRootStations() {
    return await postMessagePromised(
        window.parent,
        {
            method: "getTCPRolesWithRootStations",
            args: {},
        },
        "*",
        200,
    );
}

function sendTcpRolesWithRootStationsResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}




// WEBPACK FOOTER //
// ./src/components/handler/ParentDataHandler.js